import { render, staticRenderFns } from "./peopleAnjian.vue?vue&type=template&id=78c9c3e0&scoped=true"
import script from "./peopleAnjian.vue?vue&type=script&lang=js"
export * from "./peopleAnjian.vue?vue&type=script&lang=js"
import style0 from "./peopleAnjian.vue?vue&type=style&index=0&id=78c9c3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9c3e0",
  null
  
)

export default component.exports